"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.INHOUSE_HOST_LIST = exports.BUNNY_GOOGLE_PROXY_HOST = exports.GOOGLE_HOST = exports.PROXY_HOST = exports.INHOUSE_HOST = void 0;
/**
 * @file Keep all host names in one place.
 */

exports.INHOUSE_HOST = 'v1.padlet.pics';
exports.PROXY_HOST = 'padlet.pics';
exports.GOOGLE_HOST = 'g4.padlet.pics';
exports.BUNNY_GOOGLE_PROXY_HOST = 'g4.padlet.pics'; // current and former inhouse hosts

exports.INHOUSE_HOST_LIST = [exports.INHOUSE_HOST, 'padlet.pics', 'imgglb.padletcdn.com'];